module.exports = __webpack_public_path__ + "img/slider-home-1@2x.ba0e8a38.png";